// extracted by mini-css-extract-plugin
export default {"container":"AuthSuccess_container__zyvCj"};